import { Component, Input } from '@angular/core';
import { FeedbackItem } from '../../../model/common.model';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InputTextareaModule } from 'primeng/inputtextarea';

@Component({
  selector: 'brt-item-feedback-form',
  standalone: true,
  imports: [CommonModule, FormsModule, InputTextareaModule],
  templateUrl: './item-feedback-form.component.html',
  styleUrl: './item-feedback-form.component.css'
})
export class ItemFeedbackFormComponent {
  @Input({required: true}) feedbackItem!: FeedbackItem;
  @Input() readOnly: boolean = false;
  @Input() canReply: boolean = false;
}
